import { aggregateTypes,
     getAggregateFor,
    getAggregateForPeopleCountEE,
    getAggregateForEntryExitApp,
     getInAndOutOverTime, 
     getInAndOutStartCount,
      getHistoryCreatedOn } from "../model/reportService"

export const getWidgetStatistics = async (activeSession, field, tagid, setDuration, locationDeviceMapping) => {
    let duration = 10 * 60 * 1000;
    switch(setDuration) {
        case "Last 15 minutes": 
            duration = 15 * 60 * 1000;
            break;
        case "Last 30 minutes":
            duration = 30 * 60 * 1000;
            break;
        case "Last 1 hour":
            duration = 60 * 60 * 1000;
            break;
        case "Last 4 hours":
            duration = 4 * 60 * 60 * 1000;
            break;
        default:
            duration = 10 * 60 * 1000;
    }

     
        if(tagid) {
            let aggregationFunction = (field.includes("EE") || field.includes("OA") )? aggregateTypes.LATEST_IN_INTERVAL : aggregateTypes.SUM_WINDOW_IN_INTERVAL;
            let maxDate = new Date(Date.now() - 30000).toISOString();
            let minDate = new Date(Date.now() - duration).toISOString();
            let resp = {};
            if (aggregationFunction === aggregateTypes.LATEST_IN_INTERVAL) {
              try {
                return await getAggregatedDataForEntryExitCVApp(tagid, aggregationFunction, field, "15s", activeSession, maxDate, minDate);
              } catch (error) {
                return Array(40).fill(0);
              }
            } else {
              resp = await getAggregateFor(
                `createdon > '${minDate}'`,
                tagid,
                aggregationFunction,
                field,
                "15s",
                activeSession,
                minDate,
                maxDate
              );
            }
            
            let data = [];
            let initialValidValue = 0;

            if (resp?.peopleCount_overtime && resp?.peopleCount_overtime?.length > 0) {
                await Promise.all(resp?.peopleCount_overtime?.map(async(element, index) => {
                    let dataToPush = 0;
                    if(element?.value?.window_total_count){
                    if(element?.value?.window_total_count?.value === ""
                        || element?.value?.window_total_count?.value === null
                    ) {
                        if(index === 0) {
                        dataToPush = await getLastKnownValue(activeSession, field, duration, tagid, locationDeviceMapping)
                    } else {
                        dataToPush = data[index - 1]
                    }
                    } else  {
                        dataToPush = element?.value?.window_total_count?.value;
                    }
                }else if(element?.value?.latest){
                     if(element?.value?.latest?.value === ""
                        || element?.value?.latest?.value === null
                    ) {
                        if(index === 0) {
                        dataToPush = await getLastKnownValue(activeSession, field, duration, tagid, locationDeviceMapping)
                    } else {
                        dataToPush = initialValidValue;
                    }
                    } else  {
                        dataToPush = element?.value?.latest?.value;
                        initialValidValue = element?.value?.latest?.value;
                    }
                }
                    data.push(dataToPush);
                }));
            } else{
                data = Array(40).fill(0);
            }
            return data;
        } else {
            return Array(40).fill(0);
        }
    
    
}

export const getLastKnownValue = async(activeSession, field, duration, tagid, locationDeviceMapping) => {
  const deviceId = locationDeviceMapping?.[tagid]
   if(deviceId)
    {
    const respHisotry = await getHistoryCreatedOn(
     `createdon le '${new Date(Date.now() - duration).toISOString()}'`,
     deviceId,
     field,
     activeSession
     )
  
    const historyCount = respHisotry?.[0]?.fields?.PeopleCountEE?.count

      if(historyCount !== undefined) {
       return historyCount
      } else {
        return 0  
      }
    } else {
      return 0  
    }
    // TSCore API to fetch last known value to be implemented here.
}

const getAggregatedDataForEntryExitCVApp = async(tagid, aggregationFunction, field,fixedInterval, activeSession, maxDate, minDate  ) =>{
   const {responseData, fullresponse} =  await getAggregateForEntryExitApp(
                `(createdon > '${minDate}') and (createdon < '${maxDate}')`,
                tagid,
                aggregationFunction,
                field,
                fixedInterval,
                activeSession,
                minDate,
                maxDate
            );
            const resp = responseData;
            let data = [];
            let initialValidValue = 0;
            if (resp && resp?.length > 0) {
              resp?.map((element, index) => {
                    let dataToPush = 0;
                   if(element?.value?.latest){
                     if(element?.value?.latest?.value === ""
                        || element?.value?.latest?.value === null
                    ) {
                       
                        dataToPush = initialValidValue;
                    
                    } else  {
                        dataToPush = element?.value?.latest?.value;
                        initialValidValue = element?.value?.latest?.value;
                    }
                }
                    data.push(dataToPush);
                   
                });
                
            } else{
                data = Array(40).fill(0);
            }
             if(data.length === 1){
                        data.unshift((Object.keys(fullresponse).length == 1) ? data[0] : 0);
                    }

            return data;

}


export const getWidgetStatisticsForOA = async (activeSession, field, tagid, setDuration, locationDeviceMapping) => {
    let duration = 10 * 60 * 1000;
    switch(setDuration) {
        case "Last 15 minutes": 
            duration = 15 * 60 * 1000;
            break;
        case "Last 30 minutes":
            duration = 30 * 60 * 1000;
            break;
        case "Last 1 hour":
            duration = 60 * 60 * 1000;
            break;
        case "Last 4 hours":
            duration = 4 * 60 * 60 * 1000;
            break;
        default:
            duration = 10 * 60 * 1000;
    }

     
        if(tagid) {
            let aggregationFunction = aggregateTypes.LATEST_IN_INTERVAL ;
            let maxDate = new Date(Date.now() - 30000).toISOString();
            let minDate = new Date(Date.now() - duration).toISOString();
            let resp = {};
            
              resp = await getAggregateFor(
                `createdon > '${minDate}'`,
                tagid,
                aggregationFunction,
                field,
                "15s",
                activeSession,
                minDate,
                maxDate
              );
            
            
            let data = [];
            let initialValidValue = 0;

            if (resp?.peopleCount_overtime && resp?.peopleCount_overtime?.length > 0) {
                await Promise.all(resp?.peopleCount_overtime?.map(async(element, index) => {
                    let dataToPush = 0;
                    if(element?.value?.window_total_count){
                    if(element?.value?.window_total_count?.value === ""
                        || element?.value?.window_total_count?.value === null
                    ) {
                        if(index === 0) {
                        dataToPush = await getLastKnownValue(activeSession, field, duration, tagid, locationDeviceMapping)
                    } else {
                        dataToPush = data[index - 1]
                    }
                    } else  {
                        dataToPush = element?.value?.window_total_count?.value;
                    }
                }else if(element?.value?.latest){
                     if(element?.value?.latest?.value === ""
                        || element?.value?.latest?.value === null
                    ) {
                            dataToPush = initialValidValue;
                    }else{
                        dataToPush = element?.value?.latest?.value;
                        initialValidValue = element?.value?.latest?.value;
                    }
                    
                }
                    data.push(dataToPush);
                }));
            } else{
                data = Array(40).fill(0);
            }
            console.log(`Data for ${field} and tag ${tagid} is -> ${data}`);
            return data;
        } else {
            return Array(40).fill(0);
        }
    
    
}